const getters = {
  sidebar: state => state.app.sidebar,
  giftCards: state => state.app.giftCards,
  device: state => state.app.device,
  permission_routes: state => state.permission.routes,
  storeData: state => state.eGiftCard.dataStore,
  selectedIndex: state => state.eGiftCard.selectedIndex,
  items: state => state.cart.items,
  paymentInfo: state => state.cart.paymentInfo,
  dataCard: state => state.giftCardList.dataCard
};
export default getters;
